<template>
    <!-- Header Card -->
    <div class="section pt-1">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">പ്രൊഫഷണൽ അംഗങ്ങൾ</span>
                    <h1 class="total text-primary">{{ total }}</h1>
                </div>
                <div class="right">
                    <ion-icon name="briefcase-outline" style="font-size: 40px; color: #1a418c;"></ion-icon>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Bar -->
    <div class="section pt-0 mt-0 mb-1">
        <div class="search-form">
            <div class="input-wrapper">
                <ion-icon name="search-outline"></ion-icon>
                <input type="search" class="form-control" placeholder="Search by name or mobile..."
                    v-model="search" @input="onSearchInput" />
            </div>
        </div>
    </div>

    <!-- Filter Section -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
        <div class="accordion" id="accordionProfFilter">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#profFilterBody" aria-expanded="false">
                        <ion-icon name="filter-outline" class="me-1"></ion-icon>
                        Filter
                        <span v-if="hasActiveFilters" class="badge badge-primary ms-2" style="font-size:10px;">Active</span>
                    </button>
                </h2>
                <div id="profFilterBody" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                    data-bs-parent="#accordionProfFilter">
                    <div class="accordion-body" style="padding: 10px !important;">

                        <!-- Unit Filter -->
                        <div class="form-group">
                            <div class="input-wrapper">
                                <label class="label">Unit</label>
                                <select class="form-control custom-select" v-model="filters.unit_id"
                                    @change="loadList">
                                    <option value="">---All Units---</option>
                                    <option v-for="u in unitsList" :key="u.unit_id" :value="u.unit_id">
                                        {{ u.unit_name }} ({{ u.count }})
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Gender Filter -->
                        <div class="form-group">
                            <div class="input-wrapper">
                                <label class="label">Gender</label>
                                <select class="form-control custom-select" v-model="filters.gender"
                                    @change="loadList">
                                    <option value="">---All---</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                        </div>

                        <button class="btn btn-sm btn-secondary mt-1" @click="clearFilters">
                            <ion-icon name="close-outline"></ion-icon> Clear Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Page Title -->
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">മണ്ഡലം - പ്രൊഫഷണൽ ലിസ്റ്റ്</h3>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div class="section" v-if="loading">
        <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 mal-text">Loading...</p>
        </div>
    </div>

    <!-- Empty State -->
    <div class="section" v-if="!loading && filteredUnits.length === 0">
        <div class="text-center py-4">
            <ion-icon name="people-outline" style="font-size: 48px; color: #6c757d;"></ion-icon>
            <p class="mt-2 text-muted">No professional members found.</p>
        </div>
    </div>

    <!-- Unit-wise Grouped List -->
    <div v-if="!loading && filteredUnits.length > 0">
        <div v-for="unit in filteredUnits" :key="unit.unit_id" class="section mt-1">

            <!-- Unit Header -->
            <div class="unit-header" @click="toggleUnit(unit.unit_id)">
                <div class="unit-header-left">
                    <ion-icon name="business-outline" class="me-1"></ion-icon>
                    <span class="unit-name">{{ unit.unit_name }}</span>
                </div>
                <div class="unit-header-right">
                    <span class="badge badge-primary">{{ unit.members.length }}</span>
                    <ion-icon :name="expandedUnits[unit.unit_id] ? 'chevron-up-outline' : 'chevron-down-outline'"
                        class="ms-1"></ion-icon>
                </div>
            </div>

            <!-- Members under this unit -->
            <div v-if="expandedUnits[unit.unit_id]" class="transactions">
                <div class="item" v-for="(member, index) in unit.members" :key="member.id">
                    <div class="detail">
                        <img :src="member.gender === 'Female'
                            ? 'https://guide.msoftit.com/images/female-avatar.png'
                            : 'https://guide.msoftit.com/images/avatar-1.jpg'"
                            alt="img" class="image-block imaged w48" />
                        <div>
                            <strong>{{ index + 1 }}. {{ member.name }}</strong>
                            <p class="mb-0">
                                <ion-icon name="call-outline"></ion-icon>
                                <a :href="'tel:' + member.mobile" class="text-primary ms-1">{{ member.mobile }}</a>
                            </p>
                        </div>
                    </div>
                    <div class="right">
                        <span class="badge" :class="member.gender === 'Female' ? 'badge-danger' : 'badge-primary'">
                            {{ member.gender }}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- Expand / Collapse All buttons -->
    <div class="section mt-1 mb-3" v-if="!loading && filteredUnits.length > 1">
        <div class="d-flex gap-2 justify-content-center">
            <button class="btn btn-sm btn-outline-primary" @click="expandAll">
                <ion-icon name="expand-outline"></ion-icon> Expand All
            </button>
            <button class="btn btn-sm btn-outline-secondary" @click="collapseAll">
                <ion-icon name="contract-outline"></ion-icon> Collapse All
            </button>
        </div>
    </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
    name: "ProfessionalList",
    data() {
        return {
            loading: false,
            total: 0,
            allUnits: [],       // full response from API
            expandedUnits: {},  // { unit_id: true/false }
            search: '',
            searchTimeout: null,
            filters: {
                unit_id: '',
                gender: '',
            },
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        hasActiveFilters() {
            return this.filters.unit_id || this.filters.gender || this.search;
        },
        // Units populated from API response, used to build the Unit filter dropdown
        unitsList() {
            return this.allUnits;
        },
        // Applies client-side unit / gender / search filters on top of loaded data
        filteredUnits() {
            let units = this.allUnits;

            if (this.filters.unit_id) {
                units = units.filter(u => u.unit_id == this.filters.unit_id);
            }

            if (this.filters.gender || this.search) {
                const genderFilter = this.filters.gender;
                const searchLower  = this.search ? this.search.toLowerCase() : '';

                units = units.map(unit => {
                    let members = unit.members;

                    if (genderFilter) {
                        members = members.filter(m => m.gender === genderFilter);
                    }
                    if (searchLower) {
                        members = members.filter(m =>
                            m.name.toLowerCase().includes(searchLower) ||
                            String(m.mobile).includes(searchLower)
                        );
                    }

                    return { ...unit, members };
                }).filter(unit => unit.members.length > 0);
            }

            return units;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.$root.updateParent('Professional List');
        this.loadList();
    },
    methods: {
        onSearchInput() {
            // search is client-side, no need to re-fetch
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                // ensure expanded state follows filtered list
                this.autoExpandIfSingleUnit();
            }, 300);
        },

        clearFilters() {
            this.search = '';
            this.filters = { unit_id: '', gender: '' };
        },

        toggleUnit(unitId) {
            this.expandedUnits = {
                ...this.expandedUnits,
                [unitId]: !this.expandedUnits[unitId],
            };
        },

        expandAll() {
            const expanded = {};
            this.filteredUnits.forEach(u => { expanded[u.unit_id] = true; });
            this.expandedUnits = expanded;
        },

        collapseAll() {
            this.expandedUnits = {};
        },

        autoExpandIfSingleUnit() {
            if (this.filteredUnits.length === 1) {
                this.expandedUnits = { [this.filteredUnits[0].unit_id]: true };
            }
        },

        loadList() {
            this.loading = true;

            UserService.authGetRequest('org-professional-list').then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.total    = response.data.total || 0;
                        this.allUnits = response.data.units || [];

                        // Auto-expand when only one unit exists
                        if (this.allUnits.length === 1) {
                            this.expandedUnits = { [this.allUnits[0].unit_id]: true };
                        }
                    } else {
                        this.allUnits = [];
                        this.total    = 0;
                    }
                    this.loading = false;
                },
                () => {
                    this.allUnits = [];
                    this.total    = 0;
                    this.loading  = false;
                }
            );
        },
    },
};
</script>

<style scoped>
.unit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1a418c;
    color: #fff;
    padding: 10px 14px;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
}

.unit-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unit-header-right {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unit-name {
    font-size: 14px;
}

.transactions {
    border: 1px solid #e0e8f5;
    border-top: none;
    border-radius: 0 0 8px 8px;
    overflow: hidden;
    margin-bottom: 10px;
}

.transactions .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #f0f0f0;
    background: #fff;
}

.transactions .item:last-child {
    border-bottom: none;
}

.transactions .item .detail {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
}

.transactions .item .detail > div {
    flex: 1;
}

.transactions .item .right {
    min-width: 64px;
    text-align: right;
}

.search-form .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-form .input-wrapper ion-icon {
    position: absolute;
    left: 10px;
    font-size: 18px;
    color: #6c757d;
}

.search-form .input-wrapper input {
    padding-left: 36px;
}
</style>
